import React, { Suspense, lazy } from 'react'
import PropTypes from 'prop-types'

// FPCC
import Modal from 'components/Modal'
import Loading from 'components/Loading'
import { MEMBERS, TEAM } from 'common/constants'
import { makePlural } from 'common/utils/urlHelpers'

// Modal content kept in separate file and lazy loaded to prevent loading of QR library before onClick
const QrcodeCanvas = lazy(() => import('components/Actions/QrcodeCanvas'))

function QrcodeModal({ entry, isOpen = false, onClose }) {
  const url = `${globalThis.location.origin.toString()}/${entry?.sitename || entry?.site?.slug}/${makePlural(
    entry?.type,
  )}/${entry?.id}`

  return (
    <Modal.Presentation isOpen={isOpen} closeHandler={onClose}>
      {entry?.visibility === TEAM || entry?.visibility === MEMBERS ? (
        <div
          id="QrModalContent"
          className="inline-block text-center align-bottom space-y-5 bg-white rounded-lg p-6 lg:p-8 overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-sm sm:w-full"
        >
          <p className="text-2xl text-charcoal-900 font-bold">
            This {entry?.type} is visible to {entry?.visibility} only!
          </p>
          <p className="text-lg text-charcoal-900">
            QR Codes can only be generated for public content.
          </p>
        </div>
      ) : (
        <Suspense fallback={<Loading.Container isLoading />}>
          <div
            id="QrcodeCanvas"
            className="inline-block align-bottom space-y-5 bg-white rounded-lg p-6 lg:p-8 overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-sm sm:w-full"
          >
            <h3 className="text-center text-xl font-medium text-charcoal-900">
              QR Code:
            </h3>
            <div className="w-full flex justify-center p-2">
              <QrcodeCanvas url={url} />
            </div>
            <button
              data-testid="cancel-btn"
              type="button"
              className="btn-primary btn-md"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </Suspense>
      )}
    </Modal.Presentation>
  )
}

// PROPTYPES
const { bool, object, func } = PropTypes
QrcodeModal.propTypes = {
  entry: object,
  isOpen: bool,
  onClose: func,
}

export default QrcodeModal
